import { HourMinuteFormatted } from '../utils/dateUtil';

export const VERSION_HASH = process.env.REACT_APP_VERSION_HASH;
export const VERSION_SYSTEM_INTERVAL_SECONDS = process.env
  .REACT_APP_VERSION_SYSTEM_INTERVAL_SECONDS
  ? parseInt(process.env.REACT_APP_VERSION_SYSTEM_INTERVAL_SECONDS)
  : 60;
export const VERSION_CHECK_TRIGGER_INTERVAL_MINUTES = process.env
  .REACT_APP_VERSION_CHECK_TRIGGER_INTERVAL_MINUTES
  ? parseInt(process.env.REACT_APP_VERSION_CHECK_TRIGGER_INTERVAL_MINUTES)
  : 60;
export const VERSION_CHECK_TRIGGER_TIME: HourMinuteFormatted =
  process.env.REACT_APP_VERSION_CHECK_TRIGGER_TIME ?? '03:00';
